import {Component, computed, forwardRef, Input, input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {LinkGroup} from 'shared/pretty-easy-navigation/models';
import {PrettyEasyAccordionLinkGroupComponent} from 'shared/pretty-easy-navigation/pretty-easy-accordion-link-group/pretty-easy-accordion-link-group.component';
import {PrettyEasyImageLinkComponent} from 'shared/pretty-easy-navigation/pretty-easy-image-link/pretty-easy-image-link.component';
import {PrettyEasyLinkComponent} from 'shared/pretty-easy-navigation/pretty-easy-link/pretty-easy-link.component';

@Component({
    selector: 'app-pretty-easy-link-group',
    imports: [
        PrettyEasyLinkComponent,
        forwardRef(() => PrettyEasyAccordionLinkGroupComponent),
        TranslateModule,
        PrettyEasyImageLinkComponent,
    ],
    templateUrl: './pretty-easy-link-group.component.html'
})
export class PrettyEasyLinkGroupComponent {
    @Input() isSidebarFolded: boolean;
    @Input() unfoldSidebar: () => void;
    public slot = input<LinkGroup>();
    public links = computed(() => this.slot().links);
    public label = computed(() => this.slot().label);
    public classes = computed(() => {
        return [
            ...this.slot().classes || []
        ];
    })
}
